import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GeneralRequest } from '../../protos/auth_pb';
import { AuthServiceClient } from '../../protos/auth_grpc_web_pb';
import { AuthServerAddress } from '../../protos/server';
import GetMetadata from '../customComponents/getMetadata';

export function useGetSessions(sessionType) {
    const [stat, setStat] = useState(2)
    const [sessions, setSessions] = useState([])

    const userData = useSelector(state => state.userData)
    const stateSessions = useSelector(state => state.sessions)

    const dispatch = useDispatch()
    const authClient = new AuthServiceClient(AuthServerAddress, null, null)
    var md = GetMetadata()

    const fetchSessions = (token) => {
        const req = new GeneralRequest();
        req.setMessage(sessionType)
        md.authorization = token

        authClient.getSessions(req, md, (err, response) => {
            if (err) {
                console.log(err)
                setStat(-1)
            } else {
                const res = response.toObject()
                dispatch({ type: 'SET_SESSIONS', sessionType: sessionType, sessions: res.sessionsList });
                setSessions(res.sessionsList)
                setStat(0)
            }
        })
    }

    useEffect(() => {
        if (stateSessions[sessionType] === undefined) {
            fetchSessions(userData.token)
        } else {
            setSessions(stateSessions[sessionType])
            setStat(0)
        }
    }, [])

    return [stat, sessions]
}